<template>
  <div class="link-path-box">
    <router-link tag="span" to="/biomanager/">
      <span class="link-path">home</span>
    </router-link>
    &nbsp;/&nbsp;
    <span class="link-path">{{ currentPath }}</span>
  </div>
</template>

<script>
export default {
  name: 'LinkPath',
  props: {
    currentPath: String
  }
}
</script>

<style scoped>

.link-path-box {
  display: flex;
  margin: 1rem 0;
  font-size: 1.1rem;
  font-weight: 600;
  letter-spacing: 0.8px;
  text-transform: lowercase;
}

.link-path:hover {
  cursor: pointer;
  color: var(---2faba5-az-pix);
}

</style>



// WEBPACK FOOTER //
// LinkPath.vue?36f38f1f